import React          from 'react';
import colors         from '../../utils/colors';
import { makeStyles } from '@material-ui/core/styles';

const t1 = `על מנת להיעזר בתבניות גררו את התבניות המתאימות מתחת למספרים.`
const t2 = `כעת תוכלו לגרור ביצים אחת אחת או לסמן ביצים להעברה.`

const useStyles = makeStyles(theme => ({
    root: {
        width:              '100vw',
        height:             '100vh',
        position:           'fixed',
        display:            'flex',
        alignItems:         'center',
        justifyContent:     'center',
        flexFlow:           'column',
        zIndex:             3,
        transition:         'transform 0.4s, opacity 1s',
        backgroundColor:    'rgba(0,0,0,0.5)'
    },
    paper: {
        width:           '100vw',
        height:          '100vh',
        maxWidth:        900,
        maxHeight:       500,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        textAlign:       'center',
        flexFlow:        'column',
        backgroundColor: '#FFF',
        borderRadius:    '0.5em',
        fontSize:        23,
    },
    button: {
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        textAlign:       'center',
        marginTop:       100,
        height:          70,
        width:           150,
        fontSize:        23,
        backgroundColor: colors.blue,
        color:           '#FFF',
        borderRadius:    '0.5em',
        cursor:          'pointer'
    }
}));

type ModalProps = { 
  showHelpModal:    boolean;
  setShowHelpModal: (val: boolean) => void;
}

const Modal: React.FC<ModalProps> = ({ showHelpModal, setShowHelpModal }) => {

  const classes = useStyles();

  return (
    <div
       className = { classes.root }
       style     = {{
        transform: `translate(0px, ${ showHelpModal ? 0 : -150 }vh)`,
        opacity:   showHelpModal ? 1 : 0
    }}
    >
        <div 
           className = { classes.paper }
           dir       = 'rtl'
        >
           <div>
              { t1 }
           </div>
           <div>
              { t2 }
           </div>
           <div 
              className = { classes.button }
              onClick   = { () => { setShowHelpModal(false) }}
           >
              {`סגירה`}
           </div>
        </div>
   </div>
   )
}

export default Modal;




